import { inputDescLimit, inputTextLimit } from '../../../helpers/fieldRestriction';
import messages from '../../../locale/jsonMessages';

const validate = (values, props) => {
  const errors = {};
  const activeLanguageCodes = props?.activeLanguageCodes || [];

  if (values?.dynamicBanner) {
    let dynamicBannerError = [];
    values.dynamicBanner.map((item, index) => {
      const dynamicNameError = {};

      const isLanguageInactive = item?.language && activeLanguageCodes.length > 0
        && !activeLanguageCodes.includes(item.language);

      if (!item?.language || item?.language.toString().trim() === '' || isLanguageInactive) {
        dynamicNameError.language = messages.required;
        dynamicBannerError[index] = dynamicNameError;
      }

      if (!item?.title || item?.title.toString().trim() === '') {
        dynamicNameError.title = messages.required;
        dynamicBannerError[index] = dynamicNameError;
      } else if (item?.title?.length > inputTextLimit) {
        dynamicNameError.title = messages.inputTextLimitError;
        dynamicBannerError[index] = dynamicNameError;
      }

      if (!item?.content || item?.content.toString().trim() === '') {
        dynamicNameError.content = messages.required;
        dynamicBannerError[index] = dynamicNameError;
      } else if (item?.content?.length > inputDescLimit) {
        dynamicNameError.content = messages.inputDescLimitError;
        dynamicBannerError[index] = dynamicNameError;
      }
    });

    if (dynamicBannerError?.length > 0) errors.dynamicBanner = dynamicBannerError;
  }

  return errors;
};

export default validate;